// Cookieを設定する関数
// 分単位で有効期限を設定（ここでは10分 = 600,000ミリ秒）
// function setCookie(name, value, minutes) {
//   const d = new Date();
//   d.setTime(d.getTime() + (minutes * 60 * 1000));  // 分単位で有効期限を設定（ここでは10分 = 600,000ミリ秒）
//   const expires = "expires=" + d.toUTCString();
//   document.cookie = name + "=" + value + ";" + expires + ";path=/";
// }

// Cookieを設定する関数
// 日単位で有効期限を設定（ここでは90日 = 90 * 24 * 60 * 60 * 1000ミリ秒）
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));  // 日単位で有効期限を設定（ここでは90日 = 90 * 24 * 60 * 60 * 1000ミリ秒）
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Cookieを取得する関数
function getCookie(name) {
  const cname = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();  // 前後の空白を削除
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return "";
}

// 年齢確認ポップアップの表示・非表示を制御
window.onload = function () {
  const ageConfirmed = getCookie("ageConfirmed");

  // ageConfirmed クッキーが存在しない場合、ポップアップを表示
  if (!ageConfirmed) {
    document.getElementById("age-verification-popup").style.visibility = "visible";  // ポップアップを表示
    document.body.style.overflow = "hidden";  // 背景のスクロールを無効化
  }
}

// // 「はい、20歳以上です」ボタンが押された時の処理
// document.getElementById("confirm-age-yes").addEventListener("click", function () {
//   // setCookie("ageConfirmed", "true", 1);  // 10分間Cookieを保存
//   setCookie("ageConfirmed", "true", 90);  // 90日間Cookieを保存
//   document.getElementById("age-verification-popup").style.visibility = "hidden";  // ポップアップを非表示
//   document.body.style.overflow = "auto";  // 背景のスクロールを再度有効化
// });

const confirmYesButton = document.getElementById("confirm-age-yes");
if (confirmYesButton) {
  confirmYesButton.addEventListener("click", function () {
    // setCookie("ageConfirmed", "true", 1);  // 10分間Cookieを保存

    // Cookieを90日間保存
    setCookie("ageConfirmed", "true", 90);
    document.getElementById("age-verification-popup").style.visibility = "hidden";  // ポップアップを非表示
    document.body.style.overflow = "auto";  // 背景のスクロールを再度有効化
  });
}

// // 「いいえ、20歳未満です」ボタンが押された時の処理
// document.getElementById("confirm-age-no").addEventListener("click", function () {
//   window.location.href = "https://www.google.com";  // Googleトップページへリダイレクト
// });

// 「いいえ、20歳未満です」ボタンが存在する場合のみ処理を追加
const confirmNoButton = document.getElementById("confirm-age-no");
if (confirmNoButton) {
  confirmNoButton.addEventListener("click", function () {
    window.location.href = "https://www.google.com";  // Googleトップページへリダイレクト
  });
}


document.addEventListener('DOMContentLoaded', function() {
  var showModalBtn = document.getElementById('showModalBtn');
  var modal = document.getElementById('myModal');
  var closeBtn = document.getElementsByClassName('close')[0];

  if (showModalBtn && modal && closeBtn) {
    showModalBtn.onclick = function() {
      modal.style.display = 'block';
      setTimeout(function() {
        modal.style.opacity = 1;
      }, 10); // adding a small delay for better visual effect
    }

    // 閉じるボタンがクリックされた時の処理
    closeBtn.onclick = function() {
      modal.style.opacity = 0;
      setTimeout(function() {
        modal.style.display = 'none';
      }, 300); // transition duration is 0.3s
    }

    // モーダルの外側がクリックされた時の処理
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.opacity = 0;
        setTimeout(function() {
          modal.style.display = 'none';
        }, 300); // transition duration is 0.3s
      }
    }
  }
});


// ページが読み込まれたらスムーススクロールを適用
  document.querySelectorAll('a.p-collections-index__anchor').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault(); // デフォルトのアンカーリンク動作を無効化
      const targetId = this.getAttribute('href').substring(1); // リンク先IDを取得
      const targetElement = document.getElementById(targetId); // 対象の要素を取得
        
      // スムーススクロールを実行
      targetElement.scrollIntoView({
        behavior: 'smooth' // スムーススクロールに設定
      });
    });
  });
